export const Config = {
  apiUrl: `${import.meta.env.VITE_BASE_URL}/api/`,
  authorizeUrl: `${import.meta.env.VITE_BASE_URL}/api/auth/authorize`,

  ContinenteCredentials: {
    userRegistrationUrl: `${import.meta.env.VITE_BASE_URL}/api/web/registration/users`,
    otpResendUrl: `${import.meta.env.VITE_BASE_URL}/api/otp/resend`,
    resendLoyaltyOtpUrl: `${import.meta.env.VITE_BASE_URL}/api/otp/loyalty/resend`,
    resendEmailOtpUrl: `${import.meta.env.VITE_BASE_URL}/api/otp/email/resend`,
    passwordRecoverOtpResendUrl: `${import.meta.env.VITE_BASE_URL}/api/password-recover/resend-otp`,
    mobileUserSignInUrl: `${import.meta.env.VITE_BASE_URL}/api/username`,
    digitalAssetUrl: `${import.meta.env.VITE_BASE_URL}/api/digital-asset`,
    authorizeUrl: `${import.meta.env.VITE_BASE_URL}/api/credentials/authorize`,
    fidoCredentialOptionsUrl: `${import.meta.env.VITE_BASE_URL}/api/fido2/credential-options`,
    fidoAssertionOptionsUrl: `${import.meta.env.VITE_BASE_URL}/api/fido2/assertion-options`,
    fidoAssertionValidationUrl: `${import.meta.env.VITE_BASE_URL}/api/fido2/assertion-validate`,
    fidoCredentialRegistrationUrl: `${import.meta.env.VITE_BASE_URL}/api/fido2/credential-register`,
    connectAuthorizeUrl: `${import.meta.env.VITE_BASE_URL}/connect/authorize`,
    UserTestsUrl: `${import.meta.env.VITE_BASE_URL}/api/continente-credentials/users`,
    authorizeSSOUrl: `${import.meta.env.VITE_BASE_URL}/api/credentials/authorize/sso`,
    authorizeSRTUrl: `${import.meta.env.VITE_BASE_URL}/api/credentials/authorize/srt`,
    useFakeOTPUrl: `${import.meta.env.VITE_BASE_URL}/login_continente/v1/otp`,
  },
  SiteCredentials: {
    PasswordDefinitionUrl: `${import.meta.env.VITE_BASE_URL}/api/site-credentials/password/definition/set-password`,
    homeInformationUrl: `${import.meta.env.VITE_BASE_URL}/api/site-credentials`,
    passwordRecoverOtpResendUrl: `${import.meta.env.VITE_BASE_URL}/api/site-credentials/password/recover/resend-otp`,
    MainUrl: `/site-credentials`,
    authorizeUrl: `${import.meta.env.VITE_BASE_URL}/api/sitecredentials/authorize`,
    otpResendUrl: `${import.meta.env.VITE_BASE_URL}/api/site-credentials/otp/resend`,
    resendLoyaltyOtpUrl: `${import.meta.env.VITE_BASE_URL}/api/site-credentials/otp/loyalty/resend`,
    resendEmailOtpUrl: `${import.meta.env.VITE_BASE_URL}/api/site-credentials/otp/email/resend`,
  },
  GoogleRecaptcha: {
    Url: "https://www.google.com/recaptcha/api.js?onload=googleCallback&render=explicit",
  },
  DeepLinkActions: {
    sc_home: "sc_home",
    sc_loyaltyCard_definition: "sc_loyaltyCard_definition",
    sc_phoneNumber_definition: "sc_phoneNumber_definition",
    sc_phoneNumber_update: "sc_phoneNumber_update",
    sc_email_definition: "sc_email_definition",
    sc_email_update: "sc_email_update",
    sc_password_definition: "sc_password_definition",
    sc_password_update: "sc_password_update",
    sc_faqs: "sc_faqs",
    sc_consents: 'sc_consents'
  }
};
